import React from 'react'
import { Badge } from 'react-bootstrap'

import { formatToLocalTime } from '../../../utils/dates'

// Display-only calibration readiness + notes audit trail. The "READY FOR
// CALIBRATION" action + modal live in VehicleHeader (single entry point), so
// this component only renders the current status and the chronological notes.
const NotesHistory = ({ report }) => {
  const notes = (report.clientPortal && report.clientPortal.notes) || []
  const currentReady = report.clientPortal && report.clientPortal.calibrationReady

  if (!notes.length && !currentReady) return null

  return (
    <div className='mt-4'>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <h5 className='fw-bold mb-0'>Calibration Readiness</h5>
        {currentReady === 'yes' && <Badge bg='success'>READY</Badge>}
        {currentReady === 'no' && <Badge bg='secondary'>NOT READY</Badge>}
      </div>

      {notes.length > 0 && (
        <div className='border rounded p-3'>
          <h6 className='fw-bold mb-2'>Notes History</h6>
          {notes.map((n, idx) => (
            <div key={idx} className='border-bottom py-2'>
              <div className='d-flex justify-content-between align-items-center'>
                <Badge bg={n.status === 'yes' ? 'success' : 'secondary'} className='text-capitalize'>
                  {n.status === 'yes' ? 'Ready' : 'Not Ready'}
                </Badge>
                <small className='text-muted'>{formatToLocalTime(n.createdAt)}</small>
              </div>
              {n.text && <p className='mb-0 mt-1'>{n.text}</p>}
              {n.createdBy && <small className='text-muted'>— {n.createdBy}</small>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default NotesHistory
